module.exports = __webpack_public_path__ + "img/hp3.71b2a629.png";